import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { EN_TRANSLATIONS } from './en.translations';

/**
 * ngx-translate loader that serves the account UI dictionary straight from the
 * in-bundle `EN_TRANSLATIONS` object (extracted verbatim from the AngularJS
 * angular-translate `language.js` registrations). The account UI is single-locale
 * (`en`, `$translateProvider.preferredLanguage('en')` — no HTTP loader, no runtime
 * locale switching), so this is a synchronous `of(...)` — `TranslateService.instant`
 * resolves immediately. Any requested lang maps to the same `en` table (parity with
 * angular-translate, which only ever registered `en`).
 */
@Injectable()
export class InBundleTranslateLoader implements TranslateLoader {
  getTranslation(_lang: string): Observable<Record<string, string>> {
    return of(EN_TRANSLATIONS);
  }
}
